import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpointInsert = '/api/insertNovedad';

const api = axios.create({
    baseURL: config.baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
  (config) => {
      const token = Cookies.get('token');
      if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
  },
  (error) => {
      return Promise.reject(error);
  }
);
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const insertNovedad = async (data, tipo_novedad, id_participante, id_proyecto) => {
    try {
      const response = await axios.post(`${baseUrl}${orgEndpointInsert}`, { detalle: data, tipo_novedad:tipo_novedad, id_participante:id_participante, id_proyecto: id_proyecto }, {
        headers: {
            'Content-Type': 'application/json',  // Encabezado JSON para enviar datos correctamente
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al registrar la novedad:', error);
      throw error;
    }
  };
  export default insertNovedad;